<template>
  <v-ons-page class="l-login l-content">
    <div class="header text-center">
      <img :src="secundo_logo">
    </div>    
    <div class="loginZone">
      <div class="container">
        <p><v-ons-input id="email" placeholder="Email" modifier="material" v-model="email"></v-ons-input></p>
        <p><v-ons-input id="password" placeholder="Mot de passe / Wachtwoord" type="password" modifier="material" v-model="password"></v-ons-input></p>

        <!-- <v-ons-list>
          <v-ons-list-item tappable>
            <label class="left">
              <v-ons-checkbox input-id="check-1"></v-ons-checkbox>
            </label>
            <label for="check-1" class="center">
              Se souvenir de moi
            </label>
          </v-ons-list-item>
        </v-ons-list> -->
        <v-ons-button @click="login">Connexion / Log in</v-ons-button>
      <v-ons-button @click="password_forgotten" modifier="quiet">Mot de passe oublié ? / Vergeten wachtwoord?</v-ons-button>
      </div>
      
    </div>
  </v-ons-page>
</template>

<script>
  import { EventBus } from '../EventBus.js';

  export default {
    data () {
      return {
        email: '',
        password: '',
        secundo_logo: secundo_logo
      };
    },
    methods: {
      login() {
        if(this.email != '' && this.password != '') {
          axios
            .get('/users/get-auth', {
              params: {
                'x-secundo-auth': 'ABC123',
                'email': this.email,
                'password': this.password
              }
            })
            .then(response => {
              var user = response.data;
              if(user) {
                user.token = user._token;
                delete user._token;
                user.project = null;

                axios
                  .get('/users/project', {
                    params: {
                      'x-secundo-auth': user.token,
                      'prospect_id': user.pro_id,
                    }
                  })
                  .then(response => {
                    var project = response.data;
                    if(project) {
                      user.project = project;
                    }

                    window.loggedIn = user;
                    localStorage.loggedIn = JSON.stringify(user);
                    EventBus.$emit('navigate', 'AppSplitter');
                  });
              }
              else {
                this.$ons.notification.toast('Mauvais identifiants / Verkeerde inloggegevens', {timeout: 2000})
              }
            });
        }
      },
      password_forgotten() {
        EventBus.$emit('navigate', 'Password');
      }
    }
  }
</script>


// WEBPACK FOOTER //
// Login.vue?864012dc